import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CustomSwatch from './CustomSwatch';
import CustomSwatchesContainer from './CustomSwatchesContainer';

const CustomSwatches = ({ onChange }) => {
    const createSwatches = (onChangeHandler) => {
        const swatches = [];

        for (let i = 0; i <= 360 - 30; i += 30) {
            swatches.push(
                <CustomSwatch
                    key={`CustomSwatch${i}`}
                    onClick={() => onChangeHandler({ h: i, s: 1, l: 0.5 })}
                    style={{ backgroundColor: `hsl(${i}deg 100% 50%)` }}
                />,
            );
        }
        return swatches;
    };

    const createSwatchesMemo = useMemo(() => createSwatches(onChange), []);

    return <CustomSwatchesContainer>{createSwatchesMemo}</CustomSwatchesContainer>;
};

CustomSwatches.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default CustomSwatches;
